import { useBrand } from "@/stores/instance";

/** Stable loading screen shown while the instance profile + session restore. */
export function BootScreen() {
  const brand = useBrand();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      {brand.logoUrl ? (
        <img src={brand.logoUrl} alt="" className="h-12 w-12 rounded-lg object-cover" />
      ) : (
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent text-xl font-bold text-accent-fg">
          {brand.title.charAt(0).toUpperCase()}
        </div>
      )}
      <div className="flex items-center gap-2 text-fg-mute">
        <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" aria-hidden="true" />
        <span className="text-sm">{brand.title}</span>
      </div>
    </div>
  );
}
